import {Box, Typography} from '@mui/material';
import React, {useEffect, useState} from 'react';
import './DistributeDocuments.scss';
import {ArrToggle} from '../../../../common/arr-toggle/ArrToggle';
import ArrNumericInput from '../../../../common/arr-numeric-input/ArrNumericInput';
import {t} from 'i18next';
import ArrButton from '../../../../common/arr-button/ArrButton';
import {
  useDistributeAssignment,
  useGetDistributedDocs,
} from '../../../../../hooks/assignments/useAssignments';
import {useSelector} from 'react-redux';
import {RootState} from '../../../../../redux/store';
import ArrCheckbox from '../../../../common/arr-checkbox/ArrCheckbox';
import {ToastType} from '../../../../../shared/constants';
import ArrToastNotification from '../../../../common/arr-toast-notification/ArrToastNotification';
import {DistributeAssignmentPayload} from '../../../../../api/types/assignment.type';
type Reviewer = {
  reviewerName: string;
  emailId: string | null;
  assigned: number;
  status: string;
  completed: number;
  toDo: number;
  completedDocs: number;
  unCompletedDocs: number;
  total: number;
  today: number;
  dailyRate: number;
  reviewerId: number;
  assignmentId: number;
  checked?: boolean; // local boolean flag
};
const DistributeDocuments = () => {
  const [users, setUsers] = useState<Reviewer[]>([]);

  const {selectedData} = useSelector((state: RootState) => state.assignment);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastStatus, setToastStatus] = useState<ToastType>(ToastType.Success);
  const {data: distributeDocData, refetch} = useGetDistributedDocs(
    selectedData.assignmentId
  );
  const {mutate: distributeAssignment} = useDistributeAssignment();
  const [keepFamTog, setKeepFamTog] = useState(true);
  const [keepEmailThreadTog, setKeepEmailThreadTog] = useState(true);
  const [docToDistribute, setDocTodistibute] = useState(
    distributeDocData?.assignmentModelRes?.unAssignedDocuments
  );

  useEffect(() => {
    const initial = (distributeDocData?.assignedUsers || []).map((u) => ({
      ...u,
      checked: false,
    }));
    setUsers(initial);
    const apiUnassigned =
      distributeDocData?.assignmentModelRes.unAssignedDocuments;
    setDocTodistibute(apiUnassigned ?? 0);
  }, [distributeDocData]);

  const triggerToast = (message: string, status: ToastType) => {
    setToastMessage(message);
    setToastStatus(status);
    setShowToast(true);
  };

  const toggle = (id: number) => {
    setUsers((prev) =>
      prev.map((u) => (u.reviewerId === id ? {...u, checked: !u.checked} : u))
    );
  };

  const getSelectedReviewersPayload = () =>
    users
      .filter((u) => !!u.checked)
      .map((u) => ({ReviewerId: String(u.reviewerId)}));
  const onDistrubuteDocumentClick = () => {
    if (docToDistribute === 0 || docToDistribute === undefined) {
      triggerToast(
        t('assignment.edit.distributeDocTab.warningMessage'),
        ToastType.Warning
      );
      return;
    } else if (
      distributeDocData?.assignmentModelRes &&
      distributeDocData?.assignmentModelRes?.unAssignedDocuments <
        docToDistribute
    ) {
      triggerToast(
        t('assignment.edit.distributeDocTab.warningMessage3'),
        ToastType.Warning
      );
      return;
    } else {
      if (getSelectedReviewersPayload().length <= 0) {
        triggerToast(
          t('assignment.edit.distributeDocTab.warningMessage2'),
          ToastType.Warning
        );
        return;
      }
    }
    const payload: DistributeAssignmentPayload = {
      lstReviewers: getSelectedReviewersPayload(),
      NoOfDocToDistribute: docToDistribute,
      AssignmentID: selectedData.assignmentId.toString(),
      DistributeFamilyDocuments: keepFamTog || false,
      DistributeEmailThreadDocuments: keepEmailThreadTog || false,
    };
    distributeAssignment(payload, {
      onSuccess: () => {
        refetch?.();
        triggerToast(
          t('assignment.edit.distributeDocTab.successMessage'),
          ToastType.Success
        );
        setKeepFamTog(true);
        setKeepEmailThreadTog(true);
      },
      onError: (error) => {
        triggerToast(error?.message, ToastType.Error);
      },
    });
  };

  return (
    <>
      <Box className="distribute-assignment-container">
        <Box className="new-body-group">
          <Box className="new-input">
            <InputField
              label={t(
                'assignment.edit.distributeDocTab.totalCountOfDocInAssignment'
              )}
              type="text"
              textValue={String(
                distributeDocData?.assignmentModelRes?.totalDocuments ?? ''
              )}
              numInputDisabled={false}
              numValue={0}
              onChangeNum={() => {}}
              errorMessage={''}
            />
            <InputField
              label={t('assignment.edit.distributeDocTab.unassignedDocuments')}
              type="text"
              textValue={String(
                distributeDocData?.assignmentModelRes?.unAssignedDocuments ?? ''
              )}
              numInputDisabled={false}
              numValue={0}
              onChangeNum={() => {}}
              errorMessage={''}
            />
            <InputField
              label={t('assignment.edit.distributeDocTab.drawFromPool')}
              type="text"
              textValue={
                distributeDocData?.assignmentModelRes?.isDrawFromPool
                  ? 'Enabled'
                  : 'Disabled'
              }
              numInputDisabled={false}
              numValue={0}
              onChangeNum={() => {}}
              errorMessage={''}
            />
            <InputField
              label={t(
                'assignment.edit.distributeDocTab.countOfDocToDistribute'
              )}
              type="numInput"
              numInputDisabled={false}
              numValue={docToDistribute}
              onChangeNum={setDocTodistibute}
              errorMessage={''}
            />
            <InputField
              label={t('assignment.edit.distributeDocTab.keepFamiliesTogether')}
              type="toggle"
              toggleDisabled={false}
              toggleValue={keepFamTog}
              onChangeToggle={() => setKeepFamTog(!keepFamTog)}
            />
            <InputField
              label={t(
                'assignment.edit.distributeDocTab.keepEmailThreadsTogether'
              )}
              type="toggle"
              toggleDisabled={false}
              toggleValue={keepEmailThreadTog}
              onChangeToggle={() => setKeepEmailThreadTog(!keepEmailThreadTog)}
            />
          </Box>
          <Box className="new-input">
            <InputField
              label={t(
                'assignment.edit.distributeDocTab.selectWhichReviewerToDoc'
              )}
              type=""
              numInputDisabled={false}
              numValue={0}
              onChangeNum={() => {}}
              errorMessage={''}
            />
            <Box className="content-box">
              {users?.map((item, index) => (
                <Box className="checkbox-container" key={item.reviewerId}>
                  <ArrCheckbox
                    checked={item.checked || false}
                    onChange={() => toggle(item.reviewerId)}
                    label={String(item.reviewerId)}
                    labelText={
                      <Typography
                        className="typo-text body3_size checkbox-text"
                        noWrap
                        data-testid={`distribute-documents-name-${index}`}
                      >
                        {item.reviewerName}
                      </Typography>
                    }
                    aria-label={item.reviewerName}
                    className="checkbox"
                  />
                </Box>
              ))}
            </Box>
          </Box>
        </Box>
        <Box className="distribute-button">
          <ArrButton
            title={t('assignment.edit.distributeDocTab.distribute')}
            dataTestId={'distribute-doc-button'}
            id={t('assignment.edit.distributeDocTab.distribute')}
            name={t('assignment.edit.distributeDocTab.distribute')}
            variant="primary"
            size="small"
            onClick={() => onDistrubuteDocumentClick()}
          >
            {t('assignment.edit.distributeDocTab.distribute')}
          </ArrButton>
        </Box>
      </Box>
      {showToast && (
        <ArrToastNotification
          message={toastMessage}
          onClose={() => {
            setToastMessage('');
            setShowToast(false);
          }}
          status={[toastStatus]}
        />
      )}
    </>
  );
};

export default DistributeDocuments;

interface InputFieldProps {
  label?: string;
  type?: string;
  textValue?: string;
  errorMessage?: string;
  numInputDisabled?: boolean;
  numValue?: number | undefined;
  onChangeNum?: (newValue: number) => void | undefined;
  toggleDisabled?: boolean;
  toggleValue?: boolean;
  onChangeToggle?: () => void | undefined;
}

const InputField = ({
  label,
  type = '',
  textValue = '',
  numValue,
  onChangeNum,
  toggleValue,
  onChangeToggle,
  errorMessage = '',
  numInputDisabled = false,
  toggleDisabled = false,
}: InputFieldProps) => {
  return (
    <Box className="input-field-container">
      <Box className="title-box">
        <Typography
          className="typo-text label1_size title"
          data-testid={`${label}-title`}
        >
          {label}
          {':'}&nbsp;
        </Typography>
      </Box>
      {type && (
        <Box className="input-field-value-container">
          {type === 'text' && <Box>{textValue}</Box>}

          {type === 'numInput' && (
            <ArrNumericInput
              sizeVariant="small"
              dataTestId="doc-per-draw-input"
              showPercentage={false}
              placeholder={`${numValue === undefined ? 'Count' : '0'}`}
              value={numValue}
              onChange={onChangeNum}
              isError={errorMessage ? true : false}
              disabled={numInputDisabled}
              supportText={errorMessage}
            />
          )}
          {type === 'toggle' && (
            <ArrToggle
              dataTestId={`${label}-toggle`}
              value={toggleValue}
              onChange={onChangeToggle}
              toggleSize="small"
              disabled={toggleDisabled}
            />
          )}
        </Box>
      )}
    </Box>
  );
};
